<hr class="mt-0" />
<form [formGroup]="form" (submit)="onSave()" class="w-full">
  <div class="flex flex-column gap-2 mb-4">
    <label for="label">{{ 'layout.configurations.skillCategories.label' | translate }}</label>
    <input id="label" formControlName="label" type="text" pInputText
      [placeholder]="'layout.configurations.skillCategories.label' | translate" class="w-full"
      [ngClass]="{ 'p-invalid': isInvalid('label') || duplicateError }" />
    <div class="text-red-600" *ngIf="form.get('label')?.invalid && (form.get('label')?.touched || form.get('label')?.dirty)">
      <div *ngIf="form.get('label')?.hasError('required')">
        {{ 'layout.configurations.skillCategories.addSkillCategory.nameIsRequired' | translate }}
      </div>
      <div *ngIf="form.get('label')?.hasError('multipleSpaces')">
        {{ 'layout.configurations.skillCategories.addSkillCategory.multipleSpaces' | translate }}
      </div>
      <div *ngIf="form.get('label')?.hasError('missingLetter')">
        {{ 'layout.configurations.skillCategories.addSkillCategory.missingLetter' | translate }}
      </div>
      <div *ngIf="form.get('label')?.hasError('arabicCharacters')">
        {{ 'layout.configurations.skillCategories.addSkillCategory.arabicCharacters' | translate }}
      </div>
    </div>
    <div *ngIf="duplicateError" class="text-red-600">
      {{ (isEditMode
        ? 'layout.configurations.skillCategories.editSkillCategory.errorMessage.alreadyExists'
        : 'layout.configurations.skillCategories.addSkillCategory.errorMessage.alreadyExists') | translate }}
    </div>
  </div>
  <hr />
  <div class="flex justify-content-end mb-4">
    <p-button type="submit" icon="pi pi-check"
      [label]="'layout.configurations.skillCategories.addSkillCategory.save' | translate"></p-button>
  </div>
</form>
